module.exports = __webpack_public_path__ + "static/media/diamond.76c4f7a8.png";